import React, { ChangeEventHandler } from 'react';
import { FunctionComponent } from 'react';
import { Field, FieldRenderProps } from '../../Field';
import { Input, InputProps } from '../../Components/Input';
import { FieldContainer } from '../../Components/FieldContainer';

type Props = {
    label: string;
    description?: string;
    initialValue?: string;
};

export type TextFieldProps = Omit<
    FieldRenderProps<string>,
    'memoChild' | 'children' | 'initialValue'
> &
    Omit<
        InputProps,
        'label' | 'name' | 'onChange' | 'onBlur' | 'value' | 'defaultValue' | 'required'
    > &
    Props;

export const TextField: FunctionComponent<TextFieldProps> = ({
    id,
    name,
    label,
    description,
    initialValue,
    onBlurValidate,
    onChangeValidate,
    onSubmitValidate,
    required = false,
    ...inputProps
}) => {
    const fieldProps = {
        id,
        name,
        description,
        initialValue,
        onBlurValidate,
        onChangeValidate,
        onSubmitValidate,
        required,
    };

    return (
        <Field<string> {...fieldProps}>
            {({
                fieldId,
                value,
                setValue,
                onBlur,
                isValid,
                errors,
                errorId,
                descriptionId,
                required,
                requiredStrategy,
            }) => {
                return (
                    <FieldContainer
                        errorId={errorId}
                        errors={errors}
                        descriptionId={descriptionId}
                        description={description}
                    >
                        <Input
                            {...inputProps}
                            id={fieldId}
                            name={name}
                            label={label}
                            onChange={setValue}
                            onBlur={onBlur}
                            value={value}
                            aria-invalid={!isValid}
                            aria-errormessage={errorId}
                            aria-describedby={descriptionId}
                            required={required}
                            requiredStrategy={requiredStrategy}
                        />
                    </FieldContainer>
                );
            }}
        </Field>
    );
};
